var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "search_form" },
    [
      _c(
        "div",
        { staticClass: "search_filed" },
        [
          _c(
            "b-input-group",
            [
              _c(
                "b-input-group-text",
                { attrs: { slot: "prepend" }, slot: "prepend" },
                [_vm._v("по ПІБ, посада")]
              ),
              _vm._v(" "),
              _c("b-form-input", {
                model: {
                  value: _vm.search,
                  callback: function ($$v) {
                    _vm.search = $$v
                  },
                  expression: "search",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-overlay",
        { attrs: { show: _vm.is_load } },
        [_c("user_list", { attrs: { users: _vm.userlist } })],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }